import { render, staticRenderFns } from "./MoveAnnotation.vue?vue&type=template&id=f9800d5c&"
import script from "./MoveAnnotation.vue?vue&type=script&lang=ts&"
export * from "./MoveAnnotation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports